module.exports = __webpack_public_path__ + "img/indus-banner.522a61b7.jpg";